import ChevronDown16 from '@carbon/icons-react/es/chevron--down/16';
import React from 'react';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { Button } from 'components/atoms/button';
import { Checkbox } from 'components/atoms/checkbox';
import { DrawerContent } from 'components/organisms/timesheets/common/drawer';
import { Caption01, SingleLineEllipsis } from 'components/styles';
import { Scrollable } from 'components/styles/scrollable';

export const Content = styled(DrawerContent)`
  ${DrawerContent.Content} {
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }
`;

export const SearchInput = styled.div`
  margin: var(--spacing-05);
  position: relative;
  svg {
    position: absolute;
    right: 16px;
    top: 12px;
  }
  input {
    padding-right: 40px;
  }
`;

export const RoundedCheckbox = styled(Checkbox)`
  margin-right: var(--spacing-03);

  .ant-checkbox-inner {
    border-radius: 50%;
  }
  .ant-checkbox:hover::after {
    border-radius: 50%;
  }
`;

export const TaskListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--border-color);
  padding: var(--spacing-05);
  align-items: center;
`;

export const EmptyTaskList = styled.div`
  ${Caption01};
  color: var(--gray-70);
  padding: 0 var(--spacing-05);
  width: 80%;

  > svg {
    margin-bottom: var(--spacing-05);
  }
  ${Button} {
    padding-left: 0;
    padding-right: 0;
    margin-top: var(--spacing-08);
  }
`;

export const TaskList = styled.div<{ loading: boolean; empty: boolean }>`
  overflow: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  ${Scrollable};
  ${ifProp(
    'loading',
    css`
      align-items: center;
      justify-content: center;
    `,
  )};
  ${ifProp(
    'empty',
    css`
      justify-content: center;
    `,
  )};

  ${EmptyTaskList} {
    margin-top: var(--spacing-08);
  }
`;

export const TaskName = styled.div`
  color: var(--gray-100);
`;
export const ProjectName = styled.div`
  ${Caption01};
  color: var(--gray-80);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const TaskItem = styled(TaskListHeader)<{
  selected: boolean;
  disabled: boolean;
}>`
  cursor: pointer;
  &:hover ${RoundedCheckbox} {
    visibility: visible;
  }

  &:hover {
    background-color: var(--blue-10);
  }

  ${({ selected }) =>
    selected
      ? css`
          ${RoundedCheckbox} {
            visibility: visible;
          }
        `
      : css`
          ${RoundedCheckbox} {
            visibility: hidden;
          }
        `};
  ${({ disabled }) =>
    disabled
      ? css`
          cursor: default;

          ${TaskName}, ${ProjectName} {
            color: var(--gray-50);
          }
        `
      : ''};
`;

export const TriggerButton = styled(Button)`
  padding-right: var(--spacing-03);
  padding-left: var(--spacing-03);
  max-width: 80%;
  span {
    ${SingleLineEllipsis};
  }
`;

export const LinkTrigger = ({
  value,
}: {
  value?: { label: string };
}): JSX.Element => {
  return (
    <TriggerButton type="link" icon={<ChevronDown16 />} iconPlacement="right">
      {value?.label}
    </TriggerButton>
  );
};
